import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const contentApi = createApi({
  reducerPath: "contentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_BASE_URL}/content/`,
    prepareHeaders: (headers, { getState }) => {
      const cookies = document.cookie.split(";");
      let jwtCookie = null;

      // `.trim().startsWith("token=")` pins to the exact cookie name —
      // `.includes("token=")` would also match `refresh_token=`,
      // `g_csrf_token=`, `xsrf_token=`, etc. and overwrite the real JWT
      // when one of those sits after `token=` in document.cookie.
      cookies.map((cookie) => {
        const c = cookie.trim();
        if (c.startsWith("token=")) {
          jwtCookie = "Bearer " + c.slice("token=".length);
        }
        return null;
      });

      if (jwtCookie) {
        headers.set("authorization", jwtCookie);
      }

      return headers;
    },
  }),
  endpoints: (builder) => ({
    addDegree: builder.mutation({
      query: (body) => ({
        url: `add-degree`,
        method: "POST",
        body: body,
      }),
    }),

    addSpecaility: builder.mutation({
      query: (body) => ({
        url: `add-speciality`,
        method: "POST",
        body: body,
      }),
    }),
    degree: builder.query({
      query: () => ({
        url: `degreelist`,
        method: "GET",
      }),
    }),

    getUsaStates: builder.query({
      query: () => ({
        url: `get-usa-states`,
        method: "GET",
      }),
    }),
    suggestions: builder.query({
      query: () => ({
        url: `suggestions`,
        method: "GET",
      }),
    }),
    speciality: builder.query({
      query: () => ({
        url: `specialitylist`,
        method: "GET",
      }),
    }),

    manufacturer: builder.query({
      query: (data) => {
        let url = data?.search?.length ? `get-manufacturers?search=${data?.search}` : 'get-manufacturers';
        return {
        url,
        method: "GET",
      }},
    }),

    createManufacturer: builder.query({
      query: (data) => {
        let url = 'create-manufacturers';
        return {
        url,
        method: "POST",
          data
      }},
    }),
  }),
});

export const {
  useAddDegreeMutation,
  useAddSpecailityMutation,
  useDegreeQuery,
  useGetUsaStatesQuery,
  useSuggestionsQuery,
  useSpecialityQuery,
    useManufacturerQuery,
    useCreateManufacturerQuery
} = contentApi;
